import { useEffect, useState } from "react";

/**
 * Tracks the app's theme the same way the stylesheets do - off the
 * `data-theme` attribute the header toggle writes on <html> - so charts can
 * pick colours that were stepped for the surface they are drawn on.
 */
const useIsDarkTheme = () => {
  const [isDark, setIsDark] = useState(
    () => document.documentElement.getAttribute("data-theme") === "dark"
  );

  useEffect(() => {
    const el = document.documentElement;
    const sync = () => setIsDark(el.getAttribute("data-theme") === "dark");
    const observer = new MutationObserver(sync);
    observer.observe(el, { attributes: true, attributeFilter: ["data-theme"] });
    sync();
    return () => observer.disconnect();
  }, []);

  return isDark;
};

export default useIsDarkTheme;
